export enum TunnelKind {
  Raw,
  Structured,
}
